import {
    useFieldActionContext
} from "./context";
import type {
    NCoreUIKitIcon
} from "../../types";
import {
    EyeClosed as EyeClosedIcon,
    Eye as EyeIcon,
    X as XIcon
} from "lucide-react-native";
import AnimatedIcon from "../animatedIcon";

export const FieldClearIcon: NCoreUIKitIcon = ({
    customColor,
    color,
    size
}) => <AnimatedIcon
    customColor={customColor}
    animationTrigger="hover"
    animation="signature"
    color={color}
    icon={XIcon}
    size={size}
/>;

export const FieldVisibilityIcon: NCoreUIKitIcon = ({
    customColor,
    color,
    size
}) => {
    const {
        isPressed
    } = useFieldActionContext();

    return <AnimatedIcon
        isTransitioned={isPressed}
        customColor={customColor}
        iconTransition="morph"
        toIcon={EyeClosedIcon}
        fromIcon={EyeIcon}
        color={color}
        size={size}
    />;
};
